import { Play } from "lucide-react";
import {
  BooleanInput,
  Datagrid,
  DateField,
  DateInput,
  List,
  NumberField,
  ReferenceField,
  TextField,
} from "react-admin";
import {
  CardListActions,
  CategoryInput,
  formatDateTimeInput,
  MorePagination,
  OrganizationInput,
  SpeakerInput,
} from "../../components";

const styles = {
  sm: { minWidth: 120 },
  lg: { minWidth: 180 },
};

const filters = [
  <OrganizationInput
    label="Organization"
    source="org"
    reference="organizations"
    alwaysOn
  />,
  <SpeakerInput
    label="Speaker"
    source="speaker"
    reference="speakers"
    alwaysOn
  />,
  <CategoryInput
    label="Category"
    source="category"
    reference="categories"
    alwaysOn
  />,
  <DateInput
    label="From"
    source="date_start"
    alwaysOn
    format={formatDateTimeInput}
  />,
  <DateInput
    label="To"
    source="date_end"
    alwaysOn
    format={formatDateTimeInput}
  />,
  <BooleanInput label="Only Clips" source="is_clip" alwaysOn />,
  <BooleanInput label="Speaker Featured" source="speaker_featured" alwaysOn />,
];

function ListView(props) {
  return (
    <List
      {...props}
      actions={<CardListActions exporter={true} />}
      filters={filters}
      perPage={100}
      pagination={<MorePagination />}
      sort={{ field: "total", order: "DESC" }}
      title="Lecture Stats"
      bulkActionButtons={false}
    >
      <Datagrid rowClick="expand">
        <ReferenceField label="Title" source="id" reference="lectures">
          <TextField source="title" style={styles.lg} />
        </ReferenceField>
        <ReferenceField
          label="Category"
          source="id"
          reference="lectures"
          link={false}
        >
          <ReferenceField source="category" reference="categories" link={false}>
            <TextField source="name" style={styles.lg} />
          </ReferenceField>
        </ReferenceField>
        <ReferenceField
          label="Speaker"
          source="id"
          reference="lectures"
          link={false}
        >
          <TextField source="speaker_name" style={styles.lg} />
        </ReferenceField>
        <ReferenceField
          label="Date created"
          source="id"
          reference="lectures"
          link={false}
        >
          <DateField source="created_at" style={styles.sm} />
        </ReferenceField>
        <NumberField source="total" />
        <NumberField source="total_featured" label="Total Featured" />
        <NumberField source="video_web_user" />
        <NumberField source="video_web_nonuser" />
        <NumberField source="video_ios_user" />
        <NumberField source="video_ios_nonuser" />
        <NumberField source="video_android_user" />
        <NumberField source="video_android_nonuser" />
        <NumberField source="download_web" />
        <NumberField source="download_ios" />
        <NumberField source="download_android" />
        <NumberField source="audio_phone_nonuser" />
        <NumberField source="audio_phone" />
        <NumberField source="audio_web_user" />
        <NumberField source="audio_web_nonuser" />
        <NumberField source="audio_ios_user" />
        <NumberField source="audio_ios_nonuser" />
        <NumberField source="audio_android_user" />
        <NumberField source="audio_android_nonuser" />
        <TextField source="id" />
      </Datagrid>
    </List>
  );
}

export const LectureStats = {
  category: "stats",
  name: "stats-lectures",
  icon: Play,
  list: ListView,
  options: { label: "Lecture Stats" },
  roles: ["stat_viewer"],
  permissions: {
    stat_viewer: ["list"],
  },
};
